"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { PaymentService } from "@/views/payment/services/payment.service";
import md5 from "md5";
import { Base64 } from "js-base64";
import { throwErrorApi } from "@/shared/api/throw-error/throw-error.api";
import { guesterPaymentAPI } from "@/shared/api/guester-payment/guester-payment.api";
import { productApi } from "@/shared/api/payment/product.api";
const Fingerprint2 = require("fingerprintjs2");
export class GuesterPaymentService {
  constructor() {
    this.paymentService = new PaymentService();
    this.paymentPlatforms = [];
  }
  init() {
    return __async(this, null, function* () {
      yield this.paymentService.search("proxy");
      this.paymentPlatforms = yield this.getPlatforms();
      this.paymentService.paymentController.productSelected.platform = this.paymentPlatforms[0];
    });
  }
  // 根据productId 选中推荐的区域
  searchRecommend(id) {
    return __async(this, null, function* () {
      yield this.paymentService.paymentController.recommandchangeConfig("product", id);
    });
  }
  // 生成clientId
  createClientId() {
    return __async(this, null, function* () {
      let _components = yield Fingerprint2.getPromise({
        fonts: { extendedJsFonts: true }
      });
      let _dist = {};
      for (let _item of _components) {
        _dist[_item.key] = _item.value;
      }
      _dist.timeStrap = Date.now();
      let _speed = [
        _dist["audio"],
        _dist["availableScreenResolution"],
        _dist["colorDepth"],
        _dist["deviceMemory"],
        _dist["hardwareConcurrency"],
        _dist["plugins"],
        _dist["timezone"],
        _dist["userAgent"],
        _dist["canvas"],
        _dist["webgl"],
        _dist["webglVendorAndRenderer"],
        _dist["timeStrap"]
      ];
      let _user_id = md5(Base64.encode(_speed.toString()));
      return _user_id;
    });
  }
  // 匿名登陆
  ghostLogin(clientId) {
    return __async(this, null, function* () {
      var _a;
      try {
        const loginResponse = yield guesterPaymentAPI.ghostLogin(clientId);
        localStorage.setItem("token", (_a = loginResponse.token) != null ? _a : "");
      } catch (error) {
        throwErrorApi.throwError(error);
        return false;
      }
    });
  }
  // 检测是否为匿名用户
  checkAuthAccount() {
    return __async(this, null, function* () {
      try {
        const accountInfo = yield guesterPaymentAPI.getUserInfo();
        if (accountInfo.hasOwnProperty("temporarily") && accountInfo.temporarily === true) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        throwErrorApi.throwError(error);
        return false;
      }
    });
  }
  // 匿名购买的计算价格
  computePrice() {
    return __async(this, null, function* () {
      yield this.paymentService.computePrice("proxy");
    });
  }
  // 获取全部可用支付方式
  getPlatforms() {
    return __async(this, null, function* () {
      const methods = yield productApi.getPaymentMethods();
      return methods;
    });
  }
}
